const SESSION_ENDED = /token inv[aá]lido ou expirado|usu[aá]rio inativo ou n[aã]o encontrado|usu[aá]rio n[aã]o autenticado/i;

export function bearerFromHeaders(headers) {
  if (!headers) return '';
  const value = typeof headers.get === 'function'
    ? (headers.get('Authorization') || headers.get('authorization'))
    : (headers.Authorization || headers.authorization);
  return String(value || '').replace(/^Bearer\s+/i, '');
}

export function shouldEndAdminSession({ status, message, requestToken, currentToken }) {
  if (status !== 401) return false;
  if (!requestToken || !currentToken || requestToken !== currentToken) return false;
  return SESSION_ENDED.test(String(message || ''));
}
